module.exports = __webpack_public_path__ + "static/shopping_app-da580e77b791d2a20a519ac4404af57c.svg";